import { Button } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { MachineContext, MachineDialogMode } from 'contexts/machine.context';
import { t } from 'i18next';
import { IButton } from 'interfaces/i-buttons';
import { useContext } from 'react';

/** sends a ball-status event to the app itself to trigger the inspector */
export const MachineInspectButton = (props: IButton) => {
  const { isActive, openDialog } = useContext(MachineContext);

  return (
    <ErrorBoundary identifier="MachineInspectButton">
      <Button
        title={props.tooltip}
        color={props.color}
        variant={props.variant}
        className={props.className}
        disabled={props.disabled || !isActive}
        onClick={() => openDialog(MachineDialogMode.Inspect)}
      >
        {t('main.inspect')}
      </Button>
    </ErrorBoundary>
  );
};
